import { HiOutlineVideoCamera } from "react-icons/hi";
import { TbMoneybag } from "react-icons/tb";
import { LuTrophy } from "react-icons/lu";




export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      title: 'Pick a video and place your prediction',
      description: 'Browse live battles, analyze the odds, and bet in USDC on the video you think will win.',
      icon: <HiOutlineVideoCamera />,
      color: 'var(--color-primary)'
    },
    {
      number: '2',
      title: 'Place Your Bet',
      description: 'Predict the view count and place your bet using cryptocurrency. All transactions are secure and transparent.',
      icon: <TbMoneybag />,
      color: 'var(--color-accent)'
    },
    {
      number: '3',
      title: 'Win Rewards',
      description: 'If your prediction is accurate, win rewards proportional to your bet. Payouts are instant and automated.',
      icon: <LuTrophy />,
      color: 'var(--color-yellow)'
    }
  ];

  return (
    <section id="how-it-works" className="section">
      <div className="container">
        <div className="section-header text-center">
          <h1>How it works</h1>
          <p>Three simple steps to start predicting and earning</p>
        </div>

        <div className="grid grid-3">
          {steps.map((step, index) => (
            <div key={index} className="glass-card hiw-step-card">
              <div className="hiw-step-number">{step.number}</div>
              <div className="hiw-step-icon" style={{ color: step.color }}>{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
